import { useEffect, useState } from "react";
import type { City } from "@/apis/city/city-apis";
import { parseCityId } from "@/utils/filters";
import { useSavedCity, useSavedCityFullInfo } from "@/v2/stores";

interface UseCityReturn {
  selectedCity: string;
  savedCityFullInfo: City | null;
}

export function useCity(): UseCityReturn {
  const [selectedCity, setSelectedCity] = useState("");
  const savedCity = useSavedCity();
  const savedCityFullInfo = useSavedCityFullInfo();

  useEffect(() => {
    const cityId = parseCityId(savedCity);
    setSelectedCity(cityId ? String(cityId) : "");
  }, [savedCity]);
  return { selectedCity, savedCityFullInfo };
}
